export var MaxComponents;
(function (MaxComponents) {
    MaxComponents["Button"] = "Button";
    MaxComponents["Text"] = "Text";
    MaxComponents["Loop"] = "LoopView";
    MaxComponents["List"] = "List";
    MaxComponents["Input"] = "Input";
    MaxComponents["Dialog"] = "Dialog";
    MaxComponents["Popover"] = "Popover";
    MaxComponents["FlexLayout"] = "FlexLayout";
    MaxComponents["Icon"] = "Icon";
    MaxComponents["Column"] = "column";
    MaxComponents["Slot"] = "JSSlot";
    MaxComponents["Toast"] = "Toast";
    MaxComponents["SubPage"] = "SubPage";
    MaxComponents["FormField"] = "FormField";
    MaxComponents["Menu"] = "Menu";
    MaxComponents["Table"] = "Table";
    MaxComponents["FreeDragContainer"] = "FreeDragContainer";
    MaxComponents["Drawer"] = "Drawer";
})(MaxComponents || (MaxComponents = {}));
